import React from 'react';
import { Link } from 'react-router-dom';
import githubIcon from '../assets/icon/github.png';
import linkedinIcon from '../assets/icon/linkedin.png';
import contactIcon from '../assets/icon/contact.png';

const Footer = () => {
  return (
    <footer className="bg-[#2D2A6B]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-12">
          {/* Section supérieure */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center justify-between mb-8">
            {/* Logo et citation */}
            <div className="text-center md:text-left">
              <h3 className="text-2xl font-bold text-white mb-2">ML-Factory</h3>
              <p className="text-gray-300 italic text-lg">
                "Avec de l'entraînement, même un raté peut devenir un génie." | Rock Lee
              </p>
            </div>

            {/* Navigation rapide */}
            <div className="hidden md:flex justify-center">
              <div className="grid grid-cols-2 gap-x-8 gap-y-2">
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">Accueil</Link>
                <Link to="/competences" className="text-gray-300 hover:text-white transition-colors">Compétences</Link>
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors">Services</Link>
                <Link to="/projects" className="text-gray-300 hover:text-white transition-colors">Projects</Link>
              </div>
            </div>

            {/* Réseaux sociaux */}
            <div className="flex justify-center md:justify-end space-x-6">
              <a 
                href="https://www.linkedin.com/in/mlb-njo/"
                target="_blank"
                rel="noopener noreferrer"
                className="transform hover:scale-110 transition-transform"
              >
                <img src={linkedinIcon} alt="LinkedIn" className="w-10 h-10" />
              </a>
              <a 
                href="https://github.com/MLB-78"
                target="_blank"
                rel="noopener noreferrer"
                className="transform hover:scale-110 transition-transform"
              >
                <img src={githubIcon} alt="GitHub" className="w-10 h-10" />
              </a>
              <Link 
                to="/contact"
                className="transform hover:scale-110 transition-transform"
              >
                <img src={contactIcon} alt="Contact" className="w-10 h-10" />
              </Link>
            </div>
          </div>

          {/* Ligne de séparation */}
          <div className="border-t border-gray-700">
            <p className="mt-8 text-center text-gray-400 text-sm">
              &copy; {new Date().getFullYear()} ML-Factory. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 